import { render } from "./ModalConnect.vue?vue&type=template&id=568f012f&scoped=true&ts=true"
import script from "./ModalConnect.vue?vue&type=script&lang=ts"
export * from "./ModalConnect.vue?vue&type=script&lang=ts"

import "./ModalConnect.vue?vue&type=style&index=0&id=568f012f&lang=scss&scoped=true"

import exportComponent from "C:\\bonch\\okimi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568f012f"]])

export default __exports__